import React from 'react';
import { DeleteOutlined, DiffOutlined, LinkOutlined, DownloadOutlined, ShareAltOutlined, EditOutlined } from '@ant-design/icons';
import { RevButton } from '../Button';
import CustomButton from '../Button';
import styles from './ActionButtons.module.scss';

interface ActionButtonsProps {
  // Permissions
  canDelete: boolean;
  canShare: () => boolean;
  canDownload: () => boolean;
  canCompare: () => boolean;
  canEdit: () => boolean;
  canMultiSelect: () => boolean;
  
  // Data
  selectedItems?: Set<number>;
  fileDetail?: any;
  currentEntry?: any;
  
  // Handlers
  onDelete: () => void;
  onCompare: () => void;
  onCopyUrl?: () => void;
  onDownload?: () => void;
  onShare: () => void;
  onEdit: () => void;
  
  // Options
  hideDownload?: boolean;
  downloadLoading?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  canDelete,
  canShare,
  canDownload,
  canCompare,
  canEdit,
  canMultiSelect,
  selectedItems,
  fileDetail,
  currentEntry,
  onDelete,
  onCompare,
  onCopyUrl,
  onDownload,
  onShare,
  onEdit,
  hideDownload,
  downloadLoading
}) => {
  const hasActiveItems = () => {
    return (selectedItems && selectedItems.size > 0) || fileDetail || currentEntry;
  };



  const isMultiSelectDisabled = () => {
    return selectedItems && selectedItems.size > 1 && !canMultiSelect();
  };

  return (
    <div className={styles.buttonsContainer}>
      {canDelete && (
        <RevButton 
          icon={<DeleteOutlined />} 
          className={styles.deleteButton}
          onClick={onDelete}
          disabled={(!selectedItems || selectedItems.size === 0) && !fileDetail && !currentEntry || isMultiSelectDisabled()}
        >
          Delete
        </RevButton>
      )}
      
      {canCompare() && (
        <div className={styles.compareButtonMobile}>
          <RevButton 
            icon={<DiffOutlined />} 
            className={styles.compareButton}
            onClick={onCompare}
            disabled={isMultiSelectDisabled()}
          >
            Compare
          </RevButton>
        </div>
      )}
      
      <RevButton 
        icon={<LinkOutlined />} 
        className={styles.copyUrlButton}
        onClick={onCopyUrl}
        disabled={(selectedItems && selectedItems.size === 0) || (selectedItems && selectedItems.size > 1)}
      >
        Copy Link
      </RevButton>
      
      {canDownload() && !hideDownload && (
        <RevButton 
          icon={<DownloadOutlined />} 
          className={styles.downloadButton}
          onClick={onDownload}
          disabled={isMultiSelectDisabled()}
          loading={downloadLoading}
        >
          Download
        </RevButton>
      )}
      
            {canEdit() && (
        <RevButton
          icon={<EditOutlined />}
          className={styles.editButton}
          onClick={() => {
            onEdit();
          }}
          disabled={(() => {
            const isDisabled = (!selectedItems || selectedItems.size === 0) || (selectedItems && selectedItems.size > 1);
            
            return isDisabled;
          })()}
        >
          Edit
        </RevButton>
      )}
      
      {canShare() && (
        <CustomButton 
          icon={<ShareAltOutlined />} 
          className={styles.shareButton}
          style={{
            background: hasActiveItems() ? 'var(--app-accent-color)' : '#666'
          }}
          onClick={onShare}
          disabled={(!selectedItems || selectedItems.size === 0) || (selectedItems && selectedItems.size > 1)}
        >
          Share
        </CustomButton>
      )}
    </div>
  );
};

export default ActionButtons; 